import Vue from 'vue';
export const StoreEventBus = new Vue();

export const ADD_EDIT_STORE = 'add-edit-store';
export const SHOW_FETCH_RESULTS = 'show-fetch-results';
export const GET_STORES = 'get-stores';
